module.exports = __webpack_public_path__ + "img/img-a35e65dc.d5088e04.png";